/**
 * Shared building blocks for the two Overview pages.
 *
 * There is no route at `/Overview` any more. The page was split in two so each section owns its own
 * reporting: `src/pages/Counselling/Overview/` and `src/pages/Grow/Overview/`. This folder keeps the
 * `Components/` and `Hooks/` both of them share.
 */

/**
 * Which half of the reporting a hook should fetch.
 *
 * Every hook here takes this and does the network work for one domain only, so the Grow page never
 * polls care statistics and vice versa. Hooks are still *called* unconditionally, as the rules of
 * hooks require; it is the fetching that is skipped.
 */
export type OverviewDomain = 'care' | 'course';

/** KPI/stat poll cadence, matching `src/hooks/useSidebarCounts.ts`. */
export const OVERVIEW_POLL_MS = 60_000;

/** Rows shown in each critical-list card before "View all". */
export const CRITICAL_LIST_SIZE = 5;

/** Rows shown in each workload table before "View all". */
export const WORKLOAD_LIST_SIZE = 10;

/**
 * Breakdown bars rendered before the tail folds into "Other".
 *
 * There are 10+ care needs, so the need chart always folds; there are ~5 courses,
 * so that one never does. Past ~7 categories a ranked bar list beats more colour,
 * and a pie/donut stops being readable entirely.
 */
export const BREAKDOWN_TOP_N = 8;

/** Months in the opened-vs-closed and started-vs-completed trend charts. */
export const TREND_MONTHS = 12;
